import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Title, Meta } from "react-head";
import { PiPlusCircleFill, PiMinusCircleFill } from "react-icons/pi";
import { Element, scroller } from "react-scroll";
import { useTranslation } from "react-i18next";
import { parseTextWithLinks } from "./replaceLinks.jsx";
import ContactButton from "./ContactButton.jsx";

export default function Content() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { section } = useParams();

  const translations = i18n.getResourceBundle(i18n.language, "translation");
  const contentData = translations.services;

  const firstKey = Object.keys(contentData)[0];
  const [activeSection, setActiveSection] = useState(null);

  // Авто-открытие раздела при входе по URL
  useEffect(() => {
    if (section && contentData[section]) {
      setActiveSection(section);

      scroller.scrollTo(section, {
        duration: 800,
        smooth: "easeInOutQuart",
        offset: -20,
      });
    }
  }, []);

  // Открытие/закрытие секции + управление URL
  const toggleSection = (key) => {
    setActiveSection((prev) => {
      if (prev === key) {
        navigate("/", { replace: true });
        return null;
      } else {
        navigate(`/${key}`, { replace: true });
        return key;
      }
    });
  };

  const seo = contentData[activeSection] || translations.home;
  console.log(activeSection);
  console.log(activeSection ? `${activeSection}` : `home.keywords.${firstKey}`);
  return (
    <section
      id="content"
      className="relative bg-[url('/serviceBG.webp')] bg-cover bg-center bg-no-repeat text-[#1F2732]"
    >
      <div className="relative container mx-auto py-16 px-4">
        <h2 className="h1 md:text-4xl font-semibold mb-10">УСЛУГИ</h2>

        {/* SEO */}
        <Title>
          {seo?.title
            ? `${seo.title} – Лапшина Ирина Анатольевна`
            : "Лапшина Ирина Анатольевна"}
        </Title>

        <Meta
          name="description"
          content={seo?.description?.slice(0, 150) || ""}
        />
        <Meta
          name="keywords"
          content={[
            "юрист",
            "Наро-Фоминск",
            "Московская область",
            "Лапшина Ирина Анатольевна",

            // Интерполяция всех keywords из объекта
            ...Object.keys(seo.keywords).map((k) =>
              t(
                activeSection
                  ? `services.${activeSection}.keywords.${k}`
                  : `home.keywords.${k}`,
                { city: translations.city },
              ),
            ),
          ].join(", ")}
        />

        {/* Секции */}
        <div className="space-y-6">
          {Object.keys(contentData).map((key) => {
            const sectionItem = contentData[key];

            return (
              <Element name={key} key={key}>
                <section className="border-b pb-4">
                  {/* Заголовок */}
                  <h2
                    className="text2 md:text-2xl font-semibold flex justify-between items-center cursor-pointer py-3 transition-all"
                    onClick={() => toggleSection(key)}
                  >
                    <span>{sectionItem.button}</span>

                    <span className="transition-transform duration-300">
                      {activeSection === key ? (
                        <PiMinusCircleFill size={30} className="text-white" />
                      ) : (
                        <PiPlusCircleFill size={30} className="text-white" />
                      )}
                    </span>
                  </h2>

                  {/* Контент */}
                  <div
                    className={`overflow-hidden transition-all duration-500 ease-in-out ${
                      activeSection === key
                        ? "max-h-screen opacity-100 mt-3"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    <div className="text2 leading-relaxed space-y-4">
                      {/* text */}
                      {sectionItem.text && (
                        <p>
                          {parseTextWithLinks(
                            sectionItem.text,
                            contentData,
                            setActiveSection,
                          )}
                        </p>
                      )}

                      {/* bulletPoints */}
                      {sectionItem.bulletPoints && (
                        <ul className="list-disc pl-6 space-y-1">
                          {sectionItem.bulletPoints.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      )}

                      {/* text2 */}
                      {sectionItem.text2 && (
                        <p>
                          {parseTextWithLinks(
                            sectionItem.text2,
                            contentData,
                            setActiveSection,
                          )}
                        </p>
                      )}

                      {/* services */}
                      {sectionItem.services && (
                        <ul className="list-disc pl-6 space-y-1">
                          {sectionItem.services.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </section>
              </Element>
            );
          })}
        </div>
        <ContactButton></ContactButton>
      </div>
    </section>
  );
}
